<template lang="pug">
v-container.pa-8
  template(v-if="isFetching")
    v-row(no-gutters)
      v-col(cols="8")
        v-skeleton-loader(type="article@3")
  template(v-else)
    onboarding-review(v-if="!hasReviewAccount" :connectNow.sync="connectNow")
    review-title(:listingTab="listingTab" :key="titleKey")
    v-divider.mb-2.mb-md-6
    v-row.pb-2.pb-md-0(no-gutters)
      v-col(cols="12" md="6")
        invitation-bulk-actions(v-if="showInvitationBulkActions" :canBulkEmail="$refs.invitations.canBulkEmail" :canBulkSms="$refs.invitations.canBulkSms" @clear="$refs.invitations.clearSelection()" @sendEmail="$refs.invitations.clickEmail({bulk:true})" @sendSms="$refs.invitations.clickSms({bulk:true})")
        v-tabs(v-else v-model="listingTab" color="basic700" :height="44" :grow="isMobileScreen")
          v-tab.text-sm.font-semibold.text-capitalize.px-4 {{ $t('google_review') }}
          v-tab.text-sm.font-semibold.text-capitalize.px-4 {{ $t('internal_feedback') }}
          v-tab.text-sm.font-semibold.text-capitalize.px-4 {{ $t('invitations') }}
      v-col(cols="12" md="6" align="end")
        .d-flex.align-center.mt-2.mt-md-0
          v-spacer
          v-btn(@click="clickSearch" icon color="neutral500")
            v-icon(size="20") $yzi-search-sm
          div
            v-text-field(v-if="listingTab === 0 && showSearchField.googleReview" v-model="searchText.googleReview" @blur="blurSearch" @input="queryChanged" solo dense flat placeholder="Type to search..." hide-details clearable autofocus)
            v-text-field(v-if="listingTab === 1 && showSearchField.feedback" v-model="searchText.feedback" @blur="blurSearch" @input="queryChanged" solo dense flat placeholder="Type to search..." hide-details clearable autofocus)
            v-text-field(v-if="listingTab === 2 && showSearchField.invitation" v-model="searchText.invitation" @blur="blurSearch" @input="queryChanged" solo dense flat placeholder="Type to search..." hide-details clearable autofocus)
          v-btn.selected-button(v-if="filtersCount" @click="clickFilter" text small)
            v-icon(size="20") $yzi-filter-funnel-01
            .ml-1 {{ filtersCount }}
          v-btn(v-else @click="clickFilter" icon color="neutral500")
            v-icon(size="20") $yzi-filter-funnel-01
          customize-column-menu(type="review_invitation" :showTooltip="false" iconSize="21" :disabled="listingTab !== 2")
          v-btn(icon color="neutral500" :loading="isLoadingRefetch" @click="refetchAction({ syncGoogle:true })")
            v-icon(size="21") mdi-refresh
          div
            v-tooltip(v-if="listingTab === 2" top color="black" content-class="black tooltip-top-arrow" max-width="200px")
              template(v-slot:activator="{ on, attrs }")
                v-btn.button-sm.ml-4(@click="clickImport" v-bind="attrs" v-on="on" color="neutral700" dark depressed) Import CSV
              .text-xs.white--text Import CSV file for invitations
            v-btn.button-sm.ml-4(v-else color="neutral700" dark depressed @click="$router.push('/admin/review/add-invite')") {{ $t('get_more_reviews') }}
    v-divider
    v-tabs-items(v-model="listingTab")
      v-tab-item
        v-skeleton-loader(v-if="!hasReviewAccount" type="article@3")
        google-review-listing(v-else ref="googleReview" :key="googleReviewListingKey" :os="os" :searchText="searchText.googleReview" :filters="googleReviewFilters" @showCustomerDetails="showCustomerDetails" @toInvitationTab="listingTab = 2")
      v-tab-item
        feedback-listing(:key="feedbackListingKey" :searchText="searchText.feedback" :os="os" :filters="feedbackFilters" @showFeedbackDetails="showFeedbackDetails" @toInvitationTab="listingTab = 2")
      v-tab-item
        invitation-listing(ref="invitations" :key="invitationListingKey" :os="os" :searchText="searchText.invitation" :filters="invitationFilters" @selected="showInvitationBulkActions = true" @clear="showInvitationBulkActions = false" @refetchStats="refetchStats")

    filter-google-review-drawer(:open.sync="showGoogleReviewFilterDrawer" @done="doneFilter")
    filter-feedback-drawer(:open.sync="showFeedbackFilterDrawer" @done="doneFilter")
    filter-invitation-drawer(:open.sync="showInvitationFilterDrawer" @done="doneFilter")
    .dialogs
      review-customer-details-dialog(v-if="openReviewCustomerDetailsDialog" :open.sync="openReviewCustomerDetailsDialog" :selectedAppointment="selectedAppointment" :selectedCustomer="selectedCustomer" :os="os" @closed="onCloseDetailsDialog")
      //- review-feedback-details-dialog(v-if="openReviewFeedbackDetailsDialog" :open.sync="openReviewFeedbackDetailsDialog" :selectedAppointment="selectedAppointment" :selectedCustomer="selectedCustomer" :hasAppointment="hasAppointment" :os="os" @closed="onCloseDetailsDialog")
      import-invitation-dialog(v-if="openImportInvitationDialog" :open.sync="openImportInvitationDialog" :os="os" @onComplete="refetchAction({ syncGoogle: false })")
</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions } from 'vuex'
import CustomizeColumnMenu from '@/components/connect/CustomizeColumnMenu.vue'
import OnboardingReview from '@/components/review/general/OnboardingReview.vue'
import ReviewTitle from '@/components/review/general/ReviewTitle.vue'
import GoogleReviewListing from '@/components/review/listing/GoogleReviewListing.vue'
import FeedbackListing from '@/components/review/listing/FeedbackListing.vue'
import InvitationListing from '@/components/review/listing/InvitationListing.vue'
import InvitationBulkActions from '@/components/review/listing/InvitationBulkActions.vue'
import FilterGoogleReviewDrawer from '@/components/review/filter/FilterGoogleReviewDrawer.vue'
import FilterFeedbackDrawer from '@/components/review/filter/FilterFeedbackDrawer.vue'
import FilterInvitationDrawer from '@/components/review/filter/FilterInvitationDrawer.vue'
import ImportInvitationDialog from '@/components/review/dialogs/ImportInvitationDialog.vue'
import ReviewCustomerDetailsDialog from '@/components/review/dialogs/ReviewCustomerDetailsDialog.vue'
// import ReviewFeedbackDetailsDialog from '@/components/review/dialogs/ReviewFeedbackDetailsDialog.vue'


export default {
  name: 'ReviewListingPage',
  components: {
    CustomizeColumnMenu,
    OnboardingReview,
    ReviewTitle,
    GoogleReviewListing,
    FeedbackListing,
    InvitationListing,
    InvitationBulkActions,
    ReviewCustomerDetailsDialog,
    // ReviewFeedbackDetailsDialog,
    FilterGoogleReviewDrawer,
    FilterFeedbackDrawer,
    FilterInvitationDrawer,
    ImportInvitationDialog,
  },
  props: {
    os: {
      type: String,
      default: 'review',
      validator(value) {
        return ['clinic', 'donation', 'connect', 'review'].includes(value)
      }
    },
  },
  data() {
    return {
      isFetching: false,
      isLoadingRefetch: false,
      connectNow: false,
      listingTab: 0,
      searchText: {
        googleReview: '',
        feedback: '',
        invitation: '',
      },
      showGoogleReviewFilterDrawer: false,
      showFeedbackFilterDrawer: false,
      showInvitationFilterDrawer: false,
      showSearchField: {
        googleReview: false,
        feedback: false,
        invitation: false,
      },
      filters: null,
      showInvitationBulkActions: false,
      openReviewCustomerDetailsDialog: false,
      openReviewFeedbackDetailsDialog: false,
      selectedAppointment: null,
      selectedCustomer: null,
      hasAppointment:false,
      titleKey: 0,
      googleReviewListingKey: 0,
      feedbackListingKey: 0,
      invitationListingKey: 0,
      googleReviewFilters: [],
      feedbackFilters: [],
      invitationFilters: [],
      openImportInvitationDialog: false
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      clinic: 'clinic/getClinic',
      hasReviewAccount: 'review/hasFinishedSetup'
    }),
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    },
    filtersCount() {
      let filtersName = null
      switch (this.listingTab) {
        case 0:
          filtersName = 'googleReviewFilters'
          break;

        case 1:
          filtersName = 'feedbackFilters'
          break;

        case 2:
          filtersName = 'invitationFilters'
          break;
      
        default:
          break;
      }
      const filters = this[filtersName]
      if (filters.length > 0) {
        let count = filters.length
        let nameSeen = false
        let updatedOnSeen = false
        let postedOnSeen = false
        const names = ['name', 'name__contains', 'name__exclude']
        const dateBetweenKeys = ['date__lte', 'time__lte']
        const updatedBetweenKeys = ['updated__before', 'updated__after']
        const postedBetweenKeys = ['posted__before', 'posted__after']
        filters.forEach(item => {
          if (names.includes(item.key)) {
            if (nameSeen) {
              count--
            }
            nameSeen = true
          }
          if (updatedBetweenKeys.includes(item.key)) {
            if (updatedOnSeen) {
              count--
            }
            updatedOnSeen = true
          }
          if (postedBetweenKeys.includes(item.key)) {
            if (postedOnSeen) {
              count--
            }
            postedOnSeen = true
          }
          if (dateBetweenKeys.includes(item.key)) {
            count--
          }
        })
        return count
      }
      return 0
    },
  },
  async mounted () {
    this.isFetching = true
    const allFetching = [this.fetchSettings(), this.fetchGoogleAccount()]
    try {
      await Promise.all([...allFetching])
    } catch (error) {
      this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      return
    }
    this.checkRoute()
    this.isFetching = false
  },
  methods: {
    ...mapActions(['showMessage']),
    clickSearch() {
      let item = null
      switch (this.listingTab) {
        case 0:
          item = 'googleReview'
          break;

        case 1:
          item = 'feedback'
          break;

        case 2:
          item = 'invitation'
          break;
      }
      if (this.showSearchField[item]) {
        if (!this.searchText[item] || this.searchText[item].length === 0) {
          this.showSearchField[item] = false
        }
      } else {
        this.showSearchField[item] = true
      }
    },
    blurSearch() {
      let item = null
      switch (this.listingTab) {
        case 0:
          item = 'googleReview'
          break;

        case 1:
          item = 'feedback'
          break;

        case 2:
          item = 'invitation'
          break;
      }
      if (!this.searchText[item] || this.searchText[item].length === 0) {
        this.showSearchField[item] = false
      }
    },
    clickFilter() {
      switch (this.listingTab) {
        case 0:
          this.showGoogleReviewFilterDrawer = true
          break;

        case 1:
          this.showFeedbackFilterDrawer = true
          break;

        case 2:
          this.showInvitationFilterDrawer = true
          break;
      
        default:
          break;
      }
    },
    doneFilter(filters) {
      switch (this.listingTab) {
        case 0:
          this.googleReviewFilters = filters
          break;

        case 1:
          this.feedbackFilters = filters
          break;

        case 2:
          this.invitationFilters = filters
          break;
      
        default:
          break;
      }
      if (filters.length > 0) {
        this.showMessage(['success', this.$t('filter_applied')])
        return
      }
      this.showMessage(['success', this.$t('filter_cleared')])
    },
    checkRoute() {
      if (this.$route.query?.connect_now === 'true') {
        this.connectNow = true
      }
      if (!this.hasReviewAccount) {
        return
      }
      if (this.$route.query.tab) {
        switch (this.$route.query.tab) {
          case 'feedbacks':
            this.listingTab = 1
            break;

          case 'invitations':
            this.listingTab = 2
            break;
        
          default:
            break;
        }
      }
    },
    queryChanged: debounce(function () {
      this.refetchAction({ syncGoogle:false })
    }, 750),
    async fetchSettings() {
      return this.$axios.get(`/reviews/${this.company.slug}`).then(({ data }) => {
        this.fetchingData = data
        this.$store.commit('review/setSettings', data)
        this.$store.commit('review/setGoogleReviewUrl', data.google_review_url)
      })
    },
    fetchGoogleAccount() {
      return this.$axios.get(`reviews/${this.company.slug}/google`)
        .then(({ data }) => {
          this.$store.commit('review/setMainAccount', data)
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            return
          }
          throw error
        })
    },
    async showCustomerDetails(item) {
      if (this.os === 'clinic') {
        try {
          let params = {}
          if (this.listingTab === 0) {
            params.patient = item 
          } else {
            params.lead = item
          }
          const { data } = await this.$axios.get(`/clinics/${this.company.slug}/appointments`, { params })
          this.selectedAppointment = data.results[0]
          this.openReviewCustomerDetailsDialog = true
        } catch {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        }
        return
      }
      this.selectedCustomer = item
      this.openReviewCustomerDetailsDialog = true
    },
    async showFeedbackDetails(item) {
      if (this.os === 'clinic') {
        try {
          let params = {}
          params.lead = item.id
          const { data } = await this.$axios.get(`/clinics/${this.company.slug}/appointments`, { params })
          if (data && data.results && data.results.length > 0) {
            this.selectedAppointment = data.results[0]
          } else {
            this.selectedCustomer = item
          }
        } catch {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        }     
      } else {
        this.selectedCustomer = item
      }

      this.openReviewCustomerDetailsDialog = true
      // this.openReviewFeedbackDetailsDialog = true
      // console.log(this.openReviewFeedbackDetailsDialog)
    },
    refetchStats() {
      this.titleKey++
    },
    async refetchAction({ syncGoogle }) {
      this.isLoadingRefetch = true
      switch (this.listingTab) {
        case 0:
          if (syncGoogle) {
            await this.syncGoogle()
          }
          this.googleReviewListingKey++
          break;

        case 1:
          this.feedbackListingKey++
          break;

        case 2:
          this.invitationListingKey++
          break;
      
        default:
          break;
      }
      // Just to make sense
      setTimeout(() => {
        this.isLoadingRefetch = false
      }, 500);
      this.refetchStats()
    },
    syncGoogle() {
      return this.$axios.post(`/reviews/${this.company.slug}/sync_gmb_reviews`)
    },
    clickImport() {
      this.openImportInvitationDialog = true
    },
    onCloseDetailsDialog() {
      this.selectedCustomer = null
      this.selectedAppointment = null
    }
  }
}
</script>

<style scoped>
.selected-button {
  background: #EEEEEE !important;
  border-radius: 16px;
}
</style>